import { message } from "antd";
import { token } from "../../constants/Constants";
import { logout } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { getAllExecutives } from "../../endpoints/API";

export const fetchWellnessExecutive = async (
  setExecutives,
  baseUrl,
  prodTestUrl
) => {
  const dispatch = useDispatch;

  try {
    const response = await getAllExecutives();
    if (response.statusText=="OK") {
      const data = response?.data;
      setExecutives(data);
    } else if (response.status === 401 || response.status === 403) {
      dispatch(logout());
      localStorage.clear();
      window.location.href = "/";
      return;
      // Optional: redirect to login page
    } else {
      message.error("Failed to fetch Wellness Executives.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching Wellness Executives.");
  }
};
